import { specteraReducer } from "./spectera/specteraReducer";
import { versantReducer } from "./versant/versantReducer";
import { visionInsuranceClaimFormReducer } from "./visionInsuranceClaimFormReducer";
import { visionInsuranceReducer } from "./visionInsuranceReducer";
import { visionInsuranceReportReducer } from "./visionInsuranceReportReducer";

// const visionInsuranceReducers = {
//   rpa: visionInsuranceReducer,
//   rpaReport: visionInsuranceReportReducer,
//   rpaClaimForm: visionInsuranceClaimFormReducer,
// };

import visionInsuranceMappingReducer from "./visionInsuranceMappingReducer";

const visionInsuranceReducers = {
  visionInsurance: visionInsuranceReducer,
  visionInsuranceReport: visionInsuranceReportReducer,
  visionInsuranceClaimForm: visionInsuranceClaimFormReducer,
  specteraVisionInsurance: specteraReducer,
  visionInsuranceMapping: visionInsuranceMappingReducer,
  versantVisionInsurance: versantReducer
};
export default visionInsuranceReducers;